import React, { useState, useEffect } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import { Icon } from "@iconify/react";
import { Button, Card, Col, Form, Modal, Row } from "react-bootstrap";
import Breadcrumb from "../components/Breadcrumb";
import ReportsTable from "../components/ReportsTable";
import swal from "sweetalert";
import { API_URL } from "..";
import { Link } from "react-router-dom";

function getCurrentMonthRange() {
    const now = new Date();
    const startDate = new Date(now.getFullYear(), now.getMonth(), 1);
    const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    };
    return {
        start_date: formatDate(startDate),
        end_date: formatDate(now)
    };
}

export default function ReportsPage() {
    const { start_date, end_date } = getCurrentMonthRange();
    const [showModal, setShowModal] = useState(false);
    const [currentUser, setCurrentUser] = useState();
    const [data, setData] = useState([]);
    const [dataDashboard, setDataDashboard] = useState({
        total_income: 0,
        total_expense: 0,
    });
    const [filterValues, setFilterValues] = useState({
        start_date: start_date,
        end_date: end_date,
    });
    const [formValues, setFormValues] = useState({
        start_date: null,
        end_date: null,
        report_type: null,
    });

    const getReports = async () => {
        const user = JSON.parse(localStorage.getItem('user'));
        const apiCall = await fetch(API_URL + '/api/reports/all/' + user?.id, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': '*/*'
            }
        });
        const response = await apiCall.json();
        if (apiCall.status === 200) {
            setData(response.data);
        }
    };

    const getDashboardSummary = async () => {
        const user = JSON.parse(localStorage.getItem("user"));
        const body = JSON.stringify({
            affiliate_id: user.id,
            start_date: filterValues.start_date,
            end_date: filterValues.end_date
        });
        const apiCall = await fetch(API_URL + '/api/reports/income-expense-summary', {
            method: 'POST',
            body: body,
            headers: {
                'Content-Type': 'application/json',
                'Accept': '*/*'
            }
        });
        const response = await apiCall.json();
        if (apiCall.status === 200) {
            setDataDashboard(response);
        }
    };

    useEffect(() => {
        const getCurrentUser = () => {
            const user = localStorage.getItem("user");
            const json = JSON.parse(user);
            setCurrentUser(json);
        };
        getCurrentUser();
        getReports();
        getDashboardSummary();
    }, []);

    const onSubmitForm = async () => {
        if (!formValues.report_type) {
            swal("Validation Error", "Select the report type", "error");
            return false;
        } else if (!formValues.start_date) {
            swal("Validation Error", "Select the start date", "error");
            return false;
        } else if (!formValues.end_date) {
            swal("Validation Error", "Select the end date", "error");
            return false;
        } else {
            let body = JSON.stringify({
                report_type: formValues.report_type,
                start_date: formValues.start_date,
                end_date: formValues.end_date,
                affiliate_id: currentUser.id,
                created_by: null
            });
            const apiCall = await fetch(API_URL + '/api/reports/generate', {
                method: 'POST',
                body: body,
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': '*/*'
                }
            });
            const response = await apiCall.json();
            if (apiCall.status === 201) {
                getReports();
                swal("Report Generated", "Your report is successfully generated", "success");
                setShowModal(false);
            }
        }
    };

    return (
        <MasterLayout>
            <Breadcrumb title="Reports" />
            <div className="row mb-3">
                <div className="col-md-6">
                    <div className="row">
                        <div className="col-md-4">
                            <Form.Label>Start Date</Form.Label>
                            <Form.Control 
                                value={filterValues.start_date} 
                                onChange={(e) => setFilterValues((prev) => ({ ...prev, start_date: e.target.value }))} 
                                type="date" 
                            />
                        </div>
                        <div className="col-md-4">
                            <Form.Label>End Date</Form.Label>
                            <Form.Control 
                                value={filterValues.end_date} 
                                onChange={(e) => setFilterValues((prev) => ({ ...prev, end_date: e.target.value }))} 
                                type="date" 
                            />
                        </div>
                        <div className="col-md-4 d-flex" style={{ marginTop: 30, alignItems: 'center' }}>
                            <Button onClick={() => getDashboardSummary()}>Filter</Button>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 text-end">
                    <Button onClick={() => setShowModal(true)} variant="info">
                        Generate Report
                    </Button>
                </div>
            </div>

            <div className="row mb-3">
                <div className="col-md-3">
                    <Card className="p-3 shadow-none border bg-gradient-start-1 h-100">
                        <Link to="/reports/income">
                            <Card.Body className="p-0">
                                <div className="d-flex align-items-center gap-2">
                                    <span className="mb-0 w-48-px h-48-px bg-primary-600 text-white d-flex justify-content-center align-items-center rounded-circle h6">
                                        <Icon icon="mingcute:user-follow-fill" className="icon" />
                                    </span>
                                    <div>
                                        <span className="mb-2 fw-medium text-secondary-light text-sm">
                                            Income
                                        </span>
                                        <h6 className="fw-semibold">
                                            ${parseFloat(dataDashboard?.total_income).toFixed(2) || 0}
                                        </h6>
                                    </div>
                                </div>
                            </Card.Body>
                        </Link>
                    </Card>
                </div>
                <div className="col-md-3">
                    <Card className="p-3 shadow-none border bg-gradient-start-1 h-100">
                        <Link to="/reports/expense">
                            <Card.Body className="p-0">
                                <div className="d-flex align-items-center gap-2">
                                    <span className="mb-0 w-48-px h-48-px bg-primary-600 text-white d-flex justify-content-center align-items-center rounded-circle h6">
                                        <Icon icon="mingcute:user-follow-fill" className="icon" />
                                    </span>
                                    <div>
                                        <span className="mb-2 fw-medium text-secondary-light text-sm">
                                            Expenses
                                        </span>
                                        <h6 className="fw-semibold">
                                            ${parseFloat(dataDashboard?.total_expense).toFixed(2) || 0}
                                        </h6>
                                    </div>
                                </div>
                            </Card.Body>
                        </Link>
                    </Card>
                </div>
            </div>

            {data.length === 0 ? (
                <div className="text-center"><p>No report has been created yet.</p></div>
            ) : (
                <ReportsTable jobsData={data} />
            )}

            <Modal show={showModal} onHide={() => setShowModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title><h6>Generate Report</h6></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col md="12">
                            <Form.Label htmlFor="start_date">Select Type</Form.Label>
                            <select
                                onChange={(e) =>
                                    setFormValues((prev) => ({
                                        ...prev,
                                        report_type: e.target.value,
                                    }))
                                }
                                className="form-control"
                            >
                                <option>-- SELECT REPORT TYPE --</option>
                                <option value={"income"}>Income</option>
                                <option value={"expense"}>Expense</option>
                            </select>
                        </Col>
                        <Col md="6" className="mt-3">
                            <Form.Label htmlFor="start_date">Start Date</Form.Label>
                            <Form.Control
                                type="date"
                                value={formValues.start_date}
                                id="start_date"
                                onChange={(e) =>
                                    setFormValues((prev) => ({
                                        ...prev,
                                        start_date: e.target.value,
                                    }))
                                }
                            />
                        </Col>
                        <Col md="6" className="mt-3">
                            <Form.Label htmlFor="end_date">End Date</Form.Label>
                            <Form.Control
                                type="date"
                                id="end_date"
                                value={formValues.end_date}
                                onChange={(e) =>
                                    setFormValues((prev) => ({
                                        ...prev,
                                        end_date: e.target.value,
                                    }))
                                }
                            />
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModal(false)}>
                        Cancel
                    </Button>
                    <Button variant="primary" onClick={() => onSubmitForm()}>
                        Generate
                    </Button>
                </Modal.Footer>
            </Modal>
        </MasterLayout>
    );
}